import script from "./MainwaveGroupTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MainwaveGroupTable.vue?vue&type=script&setup=true&lang=js"

import "./MainwaveGroupTable.vue?vue&type=style&index=0&id=4cd55ca6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd55ca6"]])

export default __exports__